import React from 'react';
import HeaderOne from '../Components/Header/HeaderOne';
import AboutSection from '../Components/About/About';
import Footer from '../Components/Footer/FooterOne';
import { Helmet } from "react-helmet-async";   // ✅ correct import

function AboutPage() {
    return (
        <>
            <Helmet>
                <title>About Tickling Tummy | Best Homemade Veg Food in Coimbatore</title>
                <meta name="description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, located in R.S. Puram. We specialize in healthy daily meal subscriptions, customized pre-order tiffin services, and gourmet event catering." />
                <meta name="keywords" content="About Tickling Tummy, Homemade vegetarian food Coimbatore, Family-run food business Coimbatore, Healthy home-cooked meals Coimbatore, Pure veg food services" />
                <link rel="canonical" href="https://ticklingtummy.com/about" />
                
                {/* Open Graph Tags */}
                <meta property="og:title" content="About Tickling Tummy | Best Homemade Veg Food in Coimbatore" />
                <meta property="og:description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, located in R.S. Puram. We specialize in healthy daily meal subscriptions, customized pre-order tiffin services, and gourmet event catering." />
                <meta property="og:image" content="https://ticklingtummy.com/assets/images/about-tickling-tummy-kitchen-1.jpg" />
                <meta property="og:url" content="https://ticklingtummy.com/about" />
                <meta property="og:type" content="website" />
                
                {/* Twitter Card Tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="About Tickling Tummy | Best Homemade Veg Food in Coimbatore" />
                <meta name="twitter:description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, located in R.S. Puram. We specialize in healthy daily meal subscriptions, customized pre-order tiffin services, and gourmet event catering." />
                <meta name="twitter:image" content="https://ticklingtummy.com/assets/images/about-tickling-tummy-kitchen-1.jpg" />
            </Helmet>

        <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
  {
    "@type": "ListItem",
    "position": 1,
    "name": "Home",
    "item": "https://ticklingtummy.com"
  },
  {
    "@type": "ListItem",
    "position": 2,
    "name": "About Us",
    "item": "https://ticklingtummy.com/about"
  }
]
        }, null, 2)}
        </script>

            <HeaderOne />
            <AboutSection />
            <Footer />
        </>
    );
}

export default AboutPage;
